import React from "react";
import Image from "next/image";
import Link from "next/link";

const CardTwo = () => {
  return <>
    <div className="w-full bg-white shadow-sm lg:px-10 lg:py-5 p-6 rounded-lg">
      <div className="flex justify-between items-center">
        <div className="lg:w-3/5">
          <span className="text-base lg:text-lg">
            Original Speedcubes and Puzzles
          </span>
          <h2 className="font-serif text-lg lg:text-2xl font-bold mb-1">
            Nationwide Delivery to{" "}
            <span className="text-emerald-500">Your Home</span>
          </h2>
          <p className="text-sm font-sans leading-6">
            It does not matter if you are a professional Speedcuber or, a casual puzzle lover. We have everything for your puzzling life to flourish.
            See Our latest discounted products from here and get a special discount.
          </p>
          <Link
            href="/search?category=3x3x3"
            className="lg:w-1/4 text-xs font-serif font-medium inline-block mt-5 px-8 py-3 bg-emerald-950 text-center text-white rounded-full hover:text-white hover:bg-emerald-1000">
            
              Order now!
            
          </Link>
        </div>
        <div className="w-1/5 flex-grow hidden lg:flex md:flex md:justify-items-center lg:justify-end">
          <Image
            width={373}
            height={250}
            src="/cta/delivery-boy.png"
            alt="delivery"
            className="block w-auto"
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
        </div>
      </div>
    </div>
  </>;
};

export default CardTwo;
